module.exports = __webpack_public_path__ + "img/ctek.23a3b999.png";